import { Controller } from "@hotwired/stimulus"

const STORAGE_KEY = "field_responses_sort"

// Connects to data-controller="field-response-sort"
// Manages sort state and localStorage persistence for the Home (responses) tab.
// Open/close is delegated to the bottom-sheet controller on the same element.
export default class extends Controller {
  static targets = ["label", "sortByInput", "sortDirInput"]
  static values  = { sortBy: String, sortDir: String, frame: String }

  connect() {
    const saved = this.loadPreference()
    if (saved && (saved.sortBy !== this.sortByValue || saved.sortDir !== this.sortDirValue)) {
      this.sortByValue  = saved.sortBy
      this.sortDirValue = saved.sortDir
      this.applySort()
      return
    }
    this.updateLabel()
  }

  apply() {
    this.sortByValue  = this.sortByInputTargets.find(el => el.checked)?.value  || this.sortByValue
    this.sortDirValue = this.sortDirInputTargets.find(el => el.checked)?.value || this.sortDirValue
    this.savePreference()
    const sheet = this.application.getControllerForElementAndIdentifier(this.element, "bottom-sheet")
    if (sheet) sheet.close()
    this.applySort()
  }

  applySort() {
    const frame = document.getElementById(this.frameValue)
    if (!frame) return

    const url = new URL(window.location.href)
    url.searchParams.set("sort_by",  this.sortByValue)
    url.searchParams.set("sort_dir", this.sortDirValue)

    frame.src = url.toString()
    this.updateLabel()
  }

  updateLabel() {
    const labels = {
      created_at:   "Added",
      mission_name: "Mission",
      place_name:   "Place",
      schedule_at:  "Scheduled",
      status:       "Status"
    }
    const arrow = this.sortDirValue === "desc" ? "↓" : "↑"
    this.labelTarget.textContent = `Sort: ${labels[this.sortByValue] || "Added"} ${arrow}`
  }

  savePreference() {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ sortBy: this.sortByValue, sortDir: this.sortDirValue }))
  }

  loadPreference() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) }
    catch { return null }
  }
}
